<template lang="pug">
.duration
  treatment-duration-dropdown(v-if="item.editable && item.productItem.medication" :item="item" @dropdownOpenClosed="$emit('dropdownOpenClosed', $event)" @changed="$emit('changed', $event)")
  div.clickable(v-else-if="!item.editable && item.productItem.medication && item.productItem.medication.duration")
    span.font-medium.danger500--text(v-if="item.error") {{ item.productItem.medication.duration }}
    span(v-else) {{ item.productItem.medication.duration }}
</template>

<script>
import TreatmentDurationDropdown from '@/components/clinic/consultation/treatments/treatmentTableItems/TreatmentDurationDropdown.vue'

export default {
  components: {
    TreatmentDurationDropdown,
  },
  props: {
    item: {
      type: Object,
      required: true
    },
  }
};
</script>

<style lang="scss" scoped>
</style>